export class OTA_Document {
    public docType:             string;
    public docID:               string;
    public expireDate?:         Date;
    public docIssueLocation:    string;
    public effectiveDate?:      Date;
}
